import React from "react";
import "./CarServiceLoader.css";
export default function CarServiceLoader() {
  return (
    <div className="car-service-spinner-container">
      <div className="car-service-payment-loading-spinner"></div>
    </div>
  );
}
